import React from 'react'
import Collection from '../Components/Collection/Collection'
import './CSS/AllProducts.css'

const AllProducts = () => {
  return (
    <div className='all-products'>
      <Collection />
    </div>
  )
}

export default AllProducts;